import React from "react";
import { useNavigate } from "react-router";
import "./FAQ.css";
import yoyoLogo from "../assets/Logo YOYO.png";

const faqs = [
  {
    question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit?",
    answer:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    question: "Ut enim ad minim veniam, quis nostrud exercitation?",
    answer:
      "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  },
  {
    question: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem?",
    answer:
      "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet.",
  },
  {
    question: "Quis autem vel eum iure reprehenderit qui in ea voluptate?",
    answer:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident.",
  },
  {
    question: "Nam libero tempore cum soluta nobis eligendi optio cumque?",
    answer:
      "Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus.",
  },
  {
    question: "Quis nostrum exercitationem ullam corporis suscipit laboriosam?",
    answer:
      "Ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur.",
  },
];

function FAQ() {
  const navigate = useNavigate();

  return (
    <div className="faq-page">
      <div className="faq-container">
        <div className="faq-logo">
          <img src={yoyoLogo} alt="YOYO Logo" />
        </div>
        <h1 className="faq-title">FAQ</h1>
        <p className="faq-subtitle">Preguntas frecuentes</p>
        <div className="faq-list">
          {faqs.map((item, index) => (
            <div className="faq-item" key={index}>
              <p className="faq-question">{item.question}</p>
              <p className="faq-answer">{item.answer}</p>
            </div>
          ))}
        </div>
        <button className="faq-back" onClick={() => navigate("/")}>
          Volver al inicio
        </button>
      </div>
    </div>
  );
}

export default FAQ;
